import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews';
import Link from '@components/Link/Link';
import css from './Dropdowns.module.scss';
import MenuLink from './MenuLink';

const DropdownProduct = ({ setActiveDropdown }) => {
  const staticData = useStaticQuery(graphql`
    query HeaderProductDropdownQuery {
      prismicHeader {
        _previewable
        data {
          product_body {
            ... on PrismicHeaderDataProductBodyNavbarDropdownLinkGroup {
              id
              primary {
                title
              }
              items {
                subtitle
                title
                link {
                  url
                  target
                }
                icon {
                  url
                  gatsbyImageData(width: 20, height: 20, placeholder: NONE)
                  alt
                }
              }
            }
          }
          product_left_links {
            title
            subtitle
            link {
              url
              target
            }
            icon {
              url
              gatsbyImageData(width: 20, height: 20, placeholder: NONE)
              alt
            }
          }
          product_left_title
        }
      }
    }
  `);

  const {
    prismicHeader: { data },
  } = useMergePrismicPreviewData(staticData);

  return (
    <div className={css.megamenu}>
      <div className={css.leftMenu}>
        <h2>{data.product_left_title}</h2>
        {data.product_left_links.map(item => {
          return (
            <MenuLink
              setActiveDropdown={setActiveDropdown}
              title={item.title}
              desc={item.subtitle}
              url={item.link?.url || '#'}
              targetBlank={item.link.target}
              icon={item.icon}
            />
          );
        })}
      </div>

      <div className={css.rightMenu}>
        {data.product_body.map(group => {
          return (
            <>
              <h2>{group.primary.title}</h2>
              {group.items.map(item => {
                return (
                  <MenuLink
                    setActiveDropdown={setActiveDropdown}
                    title={item.title}
                    desc={item.subtitle}
                    url={item.link?.url || '#'}
                    targetBlank={item.link.target}
                    icon={item.icon}
                  />
                );
              })}
            </>
          );
        })}
        <Link to="/features/" className={css.bottomLink}>
          All features
          <svg width="15" height="9.374" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m14.725 5.35-3.75 3.75a.937.937 0 1 1-1.326-1.326L11.8 5.625H.937A.943.943 0 0 1 0 4.661c0-.545.42-.91.938-.91H11.8L9.65 1.6A.937.937 0 1 1 10.977.274l3.75 3.75a.938.938 0 0 1-.002 1.325Z"
              fill="#FF5257"
              fill-rule="nonzero"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default DropdownProduct;
